import React from "react";
import Sar from "../assets/images/icons/Sar";

const PriceBadge = ({ price, discounted_price, currency }) => {
  console.log("PriceBadge", price, discounted_price, currency);
  return (
    <div style={{ width: "100%" }}>
      {discounted_price && discounted_price !== price ? (
        <span>
          <span style={{ textDecoration: "line-through", color: "#bdb9b9" }}>
            {" "}
            {currency === "SAR" ? (
              <Sar color="currentcolor" />
            ) : (
              `${currency || "AED"}`
            )}{" "}
            {price}
          </span>
          <span>
            {" "}
            {currency === "SAR" ? (
              <Sar color="currentcolor" />
            ) : (
              `${currency || "AED"}`
            )}{" "}
            {discounted_price}
          </span>
        </span>
      ) : (
        <span>
          {" "}
          {currency === "SAR" ? (
            <Sar color="currentcolor" />
          ) : (
            `${currency || "AED"}`
          )}{" "}
          {price}
        </span>
      )}
    </div>
  );
};

export default PriceBadge;
